export default __webpack_public_path__ + "static/media/Golden Visa - Investment Options.e4c33bde.jpg";